module.exports = __webpack_public_path__ + "img/logo-light.99800c02.png";